import { trackEvent } from '../../modules/analytics';

export const events = {
  cancelSubscription: () =>
    trackEvent(
      'Cancel_Subscription',
      {
        eventCategory: 'Click',
        eventAction: 'Cancel Subscription Page',
        eventLabel: 'Cancel Subscription',
      },
      { providers: [ga] }
    ),
};
